import * as React from "react";
import { Icon } from "../icon/icon.mjs";
const getIconModifier = (lang, hasText) => {
  if (hasText) {
    switch (lang) {
      case "russian":
        return "#eu-sliced-ru";
      case "estonian":
        return "#eu-sliced-et";
      case "english":
      default:
        return "#eu-sliced";
    }
  }
  switch (lang) {
    case "russian":
      return "#eu-ru";
    case "estonian":
      return "#eu-et";
    case "english":
    default:
      return "#eu";
  }
};
const EuIcon = (props) => {
  const { className, lang = "english", size = "lg", text } = props;
  const BEM = () => {
    const classArray = ["eu-icon"];
    if (className) {
      classArray.push(className);
    }
    return classArray.join(" ");
  };
  return /* @__PURE__ */ React.createElement("div", { className: BEM() }, /* @__PURE__ */ React.createElement(Icon, { size, modifiers: getIconModifier(lang, !!text), className: "eu-icon__svg" }), text && /* @__PURE__ */ React.createElement("div", { className: "eu-icon__text" }, text));
};
export {
  EuIcon
};
